var map = {
	"./1.png": 9989,
	"./10.png": 3840,
	"./11.png": 9146,
	"./12.png": 8674,
	"./13.png": 7455,
	"./14.png": 1593,
	"./15.png": 7774,
	"./2.png": 9184,
	"./3.png": 6089,
	"./4.png": 3834,
	"./5.png": 9616,
	"./6.png": 518,
	"./7.png": 3650,
	"./8.png": 3413,
	"./9.png": 4830
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 3058;